import React, { useEffect, useState } from "react";
import { BarChart3, Clock } from "lucide-react";
import api from "@/lib/api";
import { Sparkline } from "@/components/meeting/Sparkline";

export default function MeetingAnalyticsPage() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/meetings/analytics/me").then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-8" data-testid="meeting-analytics-page">
      <h1 className="font-heading text-2xl font-semibold text-white flex items-center gap-2"><BarChart3 className="w-6 h-6 text-cyan-400" /> Analytics</h1>
      <p className="text-sm text-slate-400 mt-1">Your real meeting activity over the last 7 days.</p>

      {!data ? (
        <p className="text-sm text-slate-400 mt-6">Loading...</p>
      ) : (
        <div className="glass-panel rounded-2xl p-6 mt-6" data-testid="analytics-content">
          <p className="text-4xl font-bold text-white">{data.total_minutes_this_week}<span className="text-base text-slate-500 ml-1">min</span></p>
          <p className="text-sm text-slate-400 mb-4 flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> Meeting minutes this week</p>
          <Sparkline data={data.daily_breakdown.map((d) => d.minutes)} height={60} />
          <div className="grid grid-cols-8 gap-1 mt-4">
            {data.daily_breakdown.map((d) => (
              <div key={d.date} className="text-center" data-testid={`analytics-day-${d.date}`}>
                <p className="text-[10px] text-slate-500">{new Date(d.date).toLocaleDateString(undefined, { weekday: "short" })}</p>
                <p className="text-xs text-white font-semibold">{d.minutes}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
